import { Fancybox } from "@fancyapps/ui";

class FancyBox {
    constructor(passedElement) {
        this.elem = passedElement;
    }

    init() {
    Fancybox.bind('[data-fancybox]', {
        });   
    }
}


export default FancyBox;
